import React, { useState } from 'react';
import SafeIcon from '../../common/SafeIcon';
import { TREATMENT_TYPES, BODY_AREAS } from '../../data/store';
import { FiPlus, FiX, FiChevronDown } from 'react-icons/fi';

function TreatmentForm({ onAdd, onCancel }) {
  const [form, setForm] = useState({ type: '', area: '', notes: '', custom: '' });

  const handleAdd = () => {
    const type = form.type === 'custom' ? form.custom.trim() : form.type;
    if (!type) return;
    onAdd({ type, area: form.area, notes: form.notes });
  };

  return (
    <div className="glass-card rounded-[2rem] p-5 space-y-4">
      <div className="relative">
        <select
          value={form.type}
          onChange={e => setForm({ ...form, type: e.target.value })}
          className="w-full font-sans text-sm glass-input rounded-2xl px-4 py-3.5 text-slate-700 focus:outline-none appearance-none"
        >
          <option value="">Select treatment type…</option>
          {TREATMENT_TYPES.map(t => <option key={t} value={t}>{t}</option>)}
          <option value="custom">+ Custom…</option>
        </select>
        <SafeIcon icon={FiChevronDown} className="absolute right-4 top-1/2 -translate-y-1/2 text-slate-400 pointer-events-none" />
      </div>

      {form.type === 'custom' && (
        <input
          value={form.custom}
          onChange={e => setForm({ ...form, custom: e.target.value })}
          placeholder="Enter treatment name"
          className="w-full font-sans text-sm glass-input rounded-2xl px-4 py-3.5 text-slate-700 focus:outline-none"
        />
      )}

      <div className="relative">
        <select
          value={form.area}
          onChange={e => setForm({ ...form, area: e.target.value })}
          className="w-full font-sans text-sm glass-input rounded-2xl px-4 py-3.5 text-slate-700 focus:outline-none appearance-none"
        >
          <option value="">Area (optional)…</option>
          {BODY_AREAS.map(a => <option key={a} value={a}>{a}</option>)}
        </select>
        <SafeIcon icon={FiChevronDown} className="absolute right-4 top-1/2 -translate-y-1/2 text-slate-400 pointer-events-none" />
      </div>

      <textarea
        value={form.notes}
        onChange={e => setForm({ ...form, notes: e.target.value })}
        placeholder="Notes (optional)…"
        rows={3}
        className="w-full font-sans text-sm glass-input rounded-2xl px-4 py-3.5 text-slate-700 focus:outline-none resize-none"
      />

      <div className="flex gap-3 pt-2">
        <button
          onClick={onCancel}
          className="flex-1 py-3.5 rounded-2xl glass-input text-slate-600 font-sans text-sm font-medium active:scale-95 transition-transform"
        >
          Cancel
        </button>
        <button
          onClick={handleAdd}
          className="flex-1 py-3.5 rounded-2xl bg-slate-900 text-white font-sans text-sm font-medium active:scale-95 transition-transform"
        >
          Add Treatment
        </button>
      </div>
    </div>
  );
}

export default function StepTreatments({ data, onChange }) {
  const [showForm, setShowForm] = useState(false);
  const treatments = data.treatments || [];

  const addTreatment = (t) => {
    onChange({ treatments: [...treatments, t] });
    setShowForm(false);
  };

  const removeTreatment = (i) => {
    onChange({ treatments: treatments.filter((_, idx) => idx !== i) });
  };

  return (
    <div className="space-y-4">
      <p className="font-sans text-sm text-slate-500 mb-2">Log any treatments or procedures done today.</p>
      
      {treatments.map((t, i) => (
        <div key={i} className="glass-card rounded-[2rem] p-5 flex justify-between items-start">
          <div>
            <p className="font-sans font-medium text-slate-800 text-lg">💉 {t.type}</p>
            {t.area && <p className="text-sm text-slate-500 font-sans mt-1 bg-white/50 inline-block px-3 py-1 rounded-full">{t.area}</p>}
            {t.notes && <p className="text-sm text-slate-600 font-sans mt-3">"{t.notes}"</p>}
          </div>
          <button 
            onClick={() => removeTreatment(i)} 
            className="w-8 h-8 rounded-full bg-white/60 flex items-center justify-center text-slate-400 active:scale-95"
          >
            <SafeIcon icon={FiX} className="text-lg" />
          </button>
        </div>
      ))}

      {showForm ? (
        <TreatmentForm onAdd={addTreatment} onCancel={() => setShowForm(false)} />
      ) : (
        <button
          onClick={() => setShowForm(true)}
          className="w-full py-5 rounded-[2rem] glass-input text-slate-600 font-sans text-sm font-medium flex items-center justify-center gap-2 active:scale-[0.98] transition-transform border-dashed border-2"
        >
          <SafeIcon icon={FiPlus} className="text-lg" /> Add Treatment
        </button>
      )}
    </div>
  );
}